import * as React from "react";
import RbLabel from "../../../../bosch-react/components/label/RbLabel";
import RbButton, {
  ButtonType,
  ButtonSize,
} from "../../../../bosch-react/components/button/RbButton";
import CustomizedPeoplePicker from "../../../../core/components/PeoplePicker/CustomizedPeoplePicker";
import { removeAliasDomain } from "../../../../utils/converter";
import { IPersonaProps } from "@fluentui/react";

class Search_Refinement_Author extends React.Component<any, any> {
  authorsRef: React.RefObject<any> = React.createRef();

  constructor(props: any) {
    super(props);
    this.state = {
      authorText: "",
      preSelectedAuthors: []
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.setDefaultValues = this.setDefaultValues.bind(this);
  }


  render() {
    const { authorText,preSelectedAuthors } = this.state;
    const authorTextArray = authorText ? authorText.split(",") : [];
    return (
      <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <RbLabel hasPadding={true}>Author</RbLabel>
          </div>
          <div className="ms-Grid-col ms-sm12">
            <CustomizedPeoplePicker
              defaultValue={!!this.state.preSelectedAuthors ? this.state.preSelectedAuthors : []}
              objectIds={authorTextArray}
              componentRef={this.authorsRef}
              onChange={(items: IPersonaProps[]) => {
                this.setState({
                  preSelectedAuthors: items
                });
              }} />
          </div>
          <div className="ms-Grid-col ms-sm12" style={{ marginTop: "10px" }}>
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Tiny}
              label="Refine"
              style={{ minWidth: "3rem" }}
              onClick={this.handleSearch}
            />
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Tiny}
              label="Clear"
              style={{ minWidth: "3rem" }}
              onClick={this.clearSearch}
            />
          </div>
        </div>
      </div>
    );
  }

  handleSearch() {
    let items = this.authorsRef.current.getSelectedItems();
    let results: string = "";
    items.forEach((item: any) => {
      if (!!item.loginName) {
        results += `${removeAliasDomain(item.loginName)},`;
      }
    });
    this.props.handleSearch("author", results.slice(0, -1));
  }

  clearSearch() {
    this.props.handleSearch("author", "");
    this.setState({
      authorText: "",
    });
    this.authorsRef.current.setItems([]);
  }

  setDefaultValues(value: any) {
    this.setState({
      authorText: value,
    });
  }
}

export default Search_Refinement_Author;
